import ArticleContent from './ArticleContent';

export default ArticleContent;
